export default "__VITE_ASSET__Cjui4rkS__"